module.exports = __webpack_public_path__ + "img/31.a6e3f8be.png";